import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const menuItems = [
    {
        name: "顧客企業",
        path: "/control/company",
        childPath: [
            "/control/company/register",
            "/control/company/detail/:id",
            "/control/company/edit/:id",
            "/control/department/register/:id",
            "/control/position/register/:id",
        ],
    },
    {
        name: "スーパーユーザー",
        path: "/control/user",
        childPath: [
            "/control/user/register",
            "/control/user/detail/:id",
            "/control/user/edit/:id",
        ],
    },
];

const MenuItem = ({ item, isItemSelected }: any) => {
    return (
        <NavLink to={item?.path}>
        <li
            className={`h-8 px-2 py-1 rounded-2xl flex items-center justify-between gap-2 hover:cursor-pointer hover:bg-[#FF861A]/10 ${
            !item?.name ? "invisible" : ""
            }`}
        >
            <p
                className={`text-sm leading-[1.3125rem] font-bold ${
                !isItemSelected ? "alu-text-base-1" : "alu-text-base-2"
                }`}
            >
            {item?.name}
            </p>
        </li>
        </NavLink>
    );
};

const SuperUserSideMenu = () => {
    const location = useLocation();

    return (
        <ul className="h-max w-[10rem] bg-white px-4 py-10 flex flex-col gap-6 rounded-2xl alu-section-box-shadow shrink-0">
            {menuItems.map((item, idx) => (
                <MenuItem
                    key={idx}
                    item={item}
                    isItemSelected={
                        location.pathname === item.path ||
                        (item.childPath && item.childPath.some(childPath => {
                            const regex = new RegExp(`^${childPath.replace(/\/:\w+$/, '/\\d+')}$`);
                            return regex.test(location.pathname);
                        }))
                    }
                />
            ))}
        </ul>
    );
};

export default SuperUserSideMenu;
